import { gql } from '@apollo/client'

export const SEND_OTP_MUTATION = gql`
    mutation SendOTP($phone: String!) {
        sendOtp(phone: $phone) {
            status

            phone

            details

            errors {
                message

                code

                field
            }
        }
    }
`
export const VERIFY_OTP_MUTATION = gql`
    mutation VerifyOTP($otp: String!, $phone: String!) {
        verifyOtp(otp: $otp, phone: $phone) {
            status

            phone

            errors {
                message

                code

                field
            }
        }
    }
`
